import FormSectionTitle from '../../../elements/FormSectionTitle'
import { get } from 'lodash'
import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  background-color: #fff;
  color: #444;
`
const Box = styled.span`
  background-color: ${(props) => (props.isOdd ? '#fafafa' : '#FFF')};
  font-size: 100%;
  padding: 12px 12px;
  text-align: center;
  border: 0.5px solid #e8e8e8;
`

function DeliveryCollectionDisplay(props) {
  const { doc, start, end } = props
  const delivery = get(doc, 'delivery')
  const collection = get(doc, 'collection')

  const Cell = ({ header, a, b }) => (
    <>
      <Box isOdd={true}>{header}</Box>
      <Box>{a}</Box>
      <Box>{b}</Box>
    </>
  )

  return (
    <div style={{ margin: '40px' }}>
      <FormSectionTitle title={`${start || 'Collection'} And ${end || 'Delivery'} Address`} />
      <Wrapper>
        <Box isOdd={true}>*</Box>
        <Box isOdd={true}>{start || 'Collection'}</Box>
        <Box isOdd={true}>{end || 'Delivery'}</Box>
        <Cell
          {...{
            header: 'Type',
            a: get(collection, 'type'),
            b: get(delivery, 'type'),
          }}
        />
        <Cell
          {...{
            header: 'Country',
            a: get(collection, 'country'),
            b: get(delivery, 'country'),
          }}
        />
        <Cell
          {...{
            header: 'Address',
            a: get(collection, 'address.label'),
            b: get(delivery, 'address.label'),
          }}
        />
        <Cell
          {...{
            header: 'Description',
            a: get(collection, 'description'),
            b: get(delivery, 'description'),
          }}
        />
        <Cell
          {...{
            header: 'Location',
            a: get(collection, 'location'),
            b: get(delivery, 'location'),
          }}
        />
      </Wrapper>
    </div>
  )
}

export default DeliveryCollectionDisplay
